/**
 * telemetry-privacy/D3 Extension Dimensions: `context.screen` is a
 * ROUTE-TEMPLATE enum, never a raw URL, numeric id, or query string. This
 * maps a small, explicit allowlist of this app's top-level admin routes
 * (src/routes/routes.tsx); anything not listed returns `undefined`
 * (sanitize() then omits `screen` entirely) rather than inventing one.
 */
const SCREEN_BY_TOP_SEGMENT: Record<string, string> = {
  "": "dashboard",
  login: "login",
  users: "users",
  school: "schools",
  courses: "courses",
  lessons: "lessons",
  subjects: "subjects",
  resources: "resources",
  grades: "grades",
  programs: "programs",
  "game-quizzes": "game_quizzes",
  calendar: "calendar",
  activity: "activity",
  trash: "trash",
  settings: "settings",
  "revision-ods": "revision_ods",
  ventas: "sales",
  formacion: "training",
  "progreso-profesores": "teacher_progress",
};

export function mapPathToScreen(pathname: string): string | undefined {
  const withoutQuery = pathname.split("?")[0] ?? "";
  const topSegment = withoutQuery.split("/").filter(Boolean)[0] ?? "";
  return SCREEN_BY_TOP_SEGMENT[topSegment];
}
